import { render, staticRenderFns } from "./PropertyList.vue.html?vue&type=template&id=0f69cb96&lang=html&external"
import script from "./PropertyList.vue.js?vue&type=script&lang=js&external"
export * from "./PropertyList.vue.js?vue&type=script&lang=js&external"
import style0 from "./PropertyList.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports